import { gql } from '@apollo/client'

export const CREATE_COMPLIANCE_CONFIGURATION = gql`
  mutation CreateProjectComplianceConfig(
    $input: CreateProjectComplianceConfigInput!
  ) {
    createProjectComplianceConfig(input: $input) {
      config {
        id
        projectId
        categories
        complianceThresholdDays
        outreachGapDays
        maxOutreachAttempts
        createdAt
        updatedAt
      }
    }
  }
`

export const UPDATE_COMPLIANCE_CONFIGURATION = gql`
  mutation UpdateProjectComplianceConfig(
    $input: UpdateProjectComplianceConfigInput!
  ) {
    updateProjectComplianceConfig(input: $input) {
      config {
        id
        projectId
        categories
        complianceThresholdDays
        outreachGapDays
        maxOutreachAttempts
        createdAt
        updatedAt
      }
    }
  }
`

export const DELETE_COMPLIANCE_CONFIGURATION = gql`
  mutation DeleteProjectComplianceConfig($projectId: ID!) {
    deleteProjectComplianceConfig(projectId: $projectId) {
      deletedProjectId
    }
  }
`
